// Lib
import { combineReducers } from 'redux-immutable';

import deepChildrenMod from './deepChildrenModCacheReducer';

export default combineReducers({
    deepChildrenMod,
});
